import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { MatRadioChange } from '@angular/material/radio';
import { Template, TemplateListingService } from '../../../core/template-listing.service';
import { ReviewRequestType } from '../../../common/constants';
import { find } from 'lodash';

@Component({
  selector: 'app-select-template',
  templateUrl: './select-template.component.html',
  styleUrls: ['./select-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SelectTemplateComponent implements OnInit, OnChanges {
  templates$: Observable<Template[]>;
  ReviewRequestType = ReviewRequestType;
  defaultTemplateId$: Observable<string>;
  templateChecked: Template;

  @Input() disableEmailTemplates = false;
  @Input() disableSmsTemplates = false;
  @Output() selectedTemplate: EventEmitter<Template> = new EventEmitter<Template>();

  constructor(private templateListingService: TemplateListingService) {
    this.templateListingService.listTemplates();

    this.templateListingService.fetchDefaultTemplateId();

    this.templates$ = this.templateListingService.templates$;
    this.defaultTemplateId$ = this.templateListingService.defaultTemplateId$;
  }

  ngOnInit(): void {
    this.setSelectedTemplateToDefaultTemplate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disableEmailTemplates'] || changes['disableSmsTemplates']) {
      this.setSelectedTemplateToDefaultTemplate();
    }
  }

  setSelectedTemplateToDefaultTemplate(): void {
    combineLatest([this.templates$, this.defaultTemplateId$]).subscribe(([templates, defaultTemplateId]) => {
      const defaultTemplate: Template = find(
        templates,
        (template: Template) => template.templateId === defaultTemplateId,
      );
      if (!this.isTemplateDisabled(defaultTemplate)) {
        this.templateChecked = defaultTemplate;
        this.selectedTemplate.emit(defaultTemplate);
      } else {
        const nonDisabledTemplate: Template = find(
          templates,
          (template: Template) => !this.isTemplateDisabled(template),
        );
        if (nonDisabledTemplate) {
          this.templateChecked = nonDisabledTemplate;
          this.selectedTemplate.emit(nonDisabledTemplate);
        }
      }
    });
  }

  get isPreviewLoading(): boolean {
    return this.templateListingService.loadingPreview;
  }

  changeSelectedTemplate(event: MatRadioChange): void {
    this.selectedTemplate.emit(event.value);
  }

  isDefaultTemplate(templateId: string, defaultId: string): boolean {
    return defaultId.includes(templateId);
  }

  isTemplateDisabled(template: Template): boolean {
    if (template.templateType === ReviewRequestType.email) {
      return this.disableEmailTemplates;
    } else if (template.templateType === ReviewRequestType.sms) {
      return this.disableSmsTemplates;
    }
    return false;
  }

  getTemplateTooltip(templateType: ReviewRequestType): string {
    if (templateType === ReviewRequestType.email) {
      return `TEMPLATES.TEMPLATE_DISABLED_REASON_EMAIL`;
    } else if (templateType === ReviewRequestType.sms) {
      return `TEMPLATES.TEMPLATE_DISABLED_REASON_SMS`;
    }
    return ``;
  }
}
